export default "__VITE_ASSET__C$YKHyS8__"